import { AppComponent } from "./app/app.component";
import { AppRoutingModule } from "./app/app-routing.module";
import { GoogleTagManagerModule } from "angular-google-tag-manager";
import { NgxMaskModule } from "ngx-mask";
import { NgHttpLoaderModule } from "ng-http-loader";
import { provideAnimations } from "@angular/platform-browser/animations";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { ToastService } from "@app/shared/services/toast/toast.service";
import {
  ApmErrorHandler,
  ApmService,
  ApmModule
} from "@elastic/apm-rum-angular";
import { UrlParamsInterceptor } from "@app/shared/interceptors/partner/url-params-interceptor.service";
import { ServerErrorInterceptor } from "@app/shared/interceptors/server-error/server-error.interceptor";
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from "@angular/common/http";
import { AppInitializerService } from "@app/shared/services/app/app-initializer.service";
import { ConsentService } from "@app/shared/services/consent/consent.service";
import { PrivilegeService } from "@app/shared/services/privilege/privilege.service";
import {
  APP_INITIALIZER,
  ErrorHandler,
  importProvidersFrom
} from "@angular/core";

const bootstrap = () =>
  bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(
        ApmModule,
        FormsModule,
        BrowserModule,
        NgHttpLoaderModule.forRoot(),
        NgxMaskModule.forRoot(),
        GoogleTagManagerModule,
        AppRoutingModule
      ),
      {
        provide: APP_INITIALIZER,
        useFactory: (privilegeService: PrivilegeService) =>
          function () {
            return privilegeService.init();
          },
        deps: [PrivilegeService],
        multi: true
      },
      {
        provide: APP_INITIALIZER,
        useFactory: (consentService: ConsentService) =>
          function () {
            return consentService.getConsents();
          },
        deps: [ConsentService],
        multi: true
      },
      {
        provide: APP_INITIALIZER,
        useFactory: (appInitializerService: AppInitializerService) =>
          function () {
            return appInitializerService.init();
          },
        deps: [AppInitializerService],
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ServerErrorInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: UrlParamsInterceptor,
        multi: true
      },
      {
        provide: "googleTagManagerId",
        useValue: "Set from config in app.component"
      },
      {
        provide: ErrorHandler,
        useClass: ApmErrorHandler
      },
      ToastService,
      ApmService,
      provideAnimations(),
      provideHttpClient(withInterceptorsFromDi())
    ]
  });
const hideLoader = () => {
  Array.from(document.querySelectorAll(".pre-loader-container")).forEach(
    function (el: HTMLElement) {
      el.style.display = "none";
    }
  );
};

bootstrap().catch((err) => {
  if (err) {
    hideLoader();
  }
});
